






























import { Component, Vue } from "vue-property-decorator";
import comment from "./InfoCom/comment.vue";
import reply from "./InfoCom/reply.vue";
import { otherUserDownloadRecord } from "@/req/user";
@Component({
  components: {
    comment,
    reply,
  },
})
export default class Logout extends Vue {
  public modal = false;
  public bgpopup = 1;
  public formInline: any = {};
  public active = 0; // 初始默认
  public appraiseNum = "";
  public replyNum = "";
  public list: any = [];
  public noticeNum = "";
  public switch1 = "";
  public uid: any = "";

  public mounted() {
    if (this.$route.query.uid) {
      this.uid = this.$route.query.uid;
    }
    this.getList();
  }
  public async getList() {
    const res = await otherUserDownloadRecord({
      uid: this.uid,
      is_time_show: this.switch1,
    });
    if (res.code == 200) {
      this.list = res.data;
    }
  }

  public popUp() {
    this.modal = !this.modal;
  }

  public bgpopup1() {
    this.bgpopup = 1;
    this.getList();
    this.modal = !this.modal;
  }
  public bgpopup2() {
    this.bgpopup = 2;
    const arr = this.list;
    for (let i = arr.length - 1; i >= 0; i--) {
        for (let j = 0; j < i; j++) {
          // if (this.$fn.toGameTime(arr[j].add_time) > this.$fn.toGameTime(arr[j + 1].add_time)) {
          if (arr[j].game_time < arr[j + 1].game_time) {
            const k = arr[j];
            arr[j] = arr[j + 1];
            arr[j + 1] = k;
          }
        }
      }
    this.list = arr;
    this.modal = !this.modal;
  }
  //   选项卡切换
  public tabsSkip(index) {
    this.active = index;
  }
  //   接收评论总数
  public sendppraiseNum(i) {
    this.appraiseNum = i;
  }
  // 接受回复总数
  public sendReplyNum(i) {
    this.replyNum = i;
  }
  public change(status) {
    // this.$Message.info("开关状态：" + status);
    this.getList();
  }
}
